module.exports = __webpack_public_path__ + "img/currency-ethereum.5c0ef1e3.svg";